import '@/font-awesome-4.7.0/css/font-awesome.min.css';
import '@/animate-3.6.2.css';
import '@/jquery-3.3.1.js';

import 'css/global.css';
import 'js/global.js';


let apiUrl = "http://120.48.114.209:9096";

//生产环境
if (process.env.NODE_ENV === 'prod') {
    apiUrl = "http://120.48.114.209:9096"
}

(function (w, $) {
    var config = typeof w.commonConfig === "object" ? w.commonConfig : null;
    if (!!config) {
        if (typeof config.apiUrl === "string" && config.apiUrl !== "") {
            apiUrl = config.apiUrl;
        }
    }
    w.websiteConfig = {
        commonRequestUrl: apiUrl,
        tokenStringName: "token",
        commonUserInfo: { //账户基本信息
            userId: "",
            mobile: "",
            profilePic: "",
            relCorpInfo: [ //认证企业及关系信息
                //{corpInfo:{corpId: "",corpPinNo: "",corpName: "",picUrls:[{picType: "",picUrl: ""}]},custRelation:"",authResult:""}
            ],
            authCorpInfo: [ //账户关联的企业认证信息
                //{id: 0,jpaVersion: 0,createdDate: 1537950021000,lastModifiedDate: 1537950021000,corpPinNo: "",fullName: "",authResult: "CHECKING",authFailReason: null,userId: "kpTM2YVIrG1JVnDv3g",provinceCode: null,cityCode: null,zoneCode: null,address: null,saler: null,corpAuthId: "DBHhh2qP7goykQFC",auther: null,authNum: 0}
            ],
            agreementInfo: [], //合同信息
            personInfo: {}, //个人认证信息
            ifCorpV: "REJECT" //企业认证状态(CHECKING|REJECT|PASS)
        }
    };
    var rUrl = websiteConfig.commonRequestUrl;
    var tkName = websiteConfig.tokenStringName;
    var urlToken = getQueryValue(tkName); //获取并设置模拟登陆token
    if (!!urlToken) { setLocalStorage(tkName, urlToken); }
    var thisToken = getLocalStorage(tkName);
    //获取认证企业及企业钱包信息保存到本地并返回
    w.getAccountVerifiedCorps = function (that) {
        var requestUrl1 = rUrl + "/wallet/getCorpInfoByUserId/";
        var accountVerifiedCorpsArr = [];
        $.ajax({
            async: false,
            type: "GET",
            url: requestUrl1,
            beforeSend: function (request) {
                request.setRequestHeader("token", thisToken);
            },
            success: function (data) {
                var code1 = data.code;
                var content1 = data.content;
                if (code1 === 0) {
                    if (thisIsArray(content1) && content1.length > 0) {
                        for (var i = 0; i < content1.length; i++) {
                            var _corpPinNo = content1[i].corpPinNo;
                            var _fullName = content1[i].fullName;
                            var oneCorpInfo = {
                                corpPinNo: _corpPinNo,
                                fullName: _fullName,
                                isOpen: null,
                                userId: null
                            };
                            var requestUrl2 = rUrl + "/wallet/judgeCreateAccount?corpPinNo=" + _corpPinNo;
                            $.ajax({
                                async: false,
                                type: "GET",
                                url: requestUrl2,
                                beforeSend: function (request) {
                                    request.setRequestHeader("token", thisToken);
                                },
                                success: function (data) {
                                    var code2 = data.code;
                                    var content2 = data.content;
                                    if (code2 === 0) {
                                        if (thisIsObject(content2) && JSON.stringify(content2) !== "{}") {
                                            var _isOpen = content2.isOpen;
                                            var _userId = content2.userId;
                                            oneCorpInfo.isOpen = _isOpen;
                                            oneCorpInfo.userId = _userId;
                                        }
                                    }
                                },
                                error: function (error) {
                                    console.log(error);
                                }
                            });
                            if (!!that && thisIsArray(that.accountVerifiedCorps)) {
                                that.accountVerifiedCorps.push(oneCorpInfo);
                            }
                            accountVerifiedCorpsArr.push(oneCorpInfo);
                        }
                    }
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
        setLocalStorage("accountVerifiedCorps", accountVerifiedCorpsArr);
        return accountVerifiedCorpsArr;
    };
    //获取账户基本信息保存到本地并返回
    $.getCommonUserInfo = function () {
        if (!!thisToken && thisToken !== "") {
            var requestUrl = rUrl + "/user/info/";
            $.ajax({
                async: false,
                type: "GET",
                url: requestUrl,
                beforeSend: function (request) {
                    request.setRequestHeader("token", thisToken);
                },
                success: function (data) {
                    var code = data.code;
                    var msg = data.msg;
                    var content = data.content;
                    if (code === 0) {
                        if (typeof content.userId === "string" && content.userId.trim() !== "") {
                            websiteConfig.commonUserInfo.userId = content.userId;
                        }
                        if (typeof content.mobile === "string" && content.mobile.trim() !== "") {
                            websiteConfig.commonUserInfo.mobile = content.mobile;
                        }
                        if (typeof content.profilePic === "string" && content.profilePic.trim() !== "") {
                            websiteConfig.commonUserInfo.profilePic = content.profilePic;
                        }
                        if (thisIsArray(content.relCorpInfo) && content.relCorpInfo.length > 0) {
                            websiteConfig.commonUserInfo.relCorpInfo = content.relCorpInfo;
                        }
                        if (thisIsArray(content.authCorpInfo) && content.authCorpInfo.length > 0) {
                            websiteConfig.commonUserInfo.authCorpInfo = content.authCorpInfo;
                            //判断第一个企业的认证状态作为账户企业认证状态(临时使用)
                            var _firstCorp = websiteConfig.commonUserInfo.authCorpInfo[0];
                            if (thisIsObject(_firstCorp) && typeof _firstCorp.authResult === "string" && _firstCorp.authResult !== "") {
                                websiteConfig.commonUserInfo.ifCorpV = _firstCorp.authResult;
                            }
                        }
                        if (thisIsArray(content.agreementInfo) && content.agreementInfo.length > 0) {
                            websiteConfig.commonUserInfo.agreementInfo = content.agreementInfo;
                        }
                        if (thisIsObject(content.personInfo) && JSON.stringify(content.personInfo) !== "{}") {
                            websiteConfig.commonUserInfo.personInfo = content.personInfo;
                        }
                    } else {
                        alert("查询账户信息失败");
                        removeLocalStorage(tkName);
                        w.location.href = "login.html";
                    }
                },
                error: function (error) {
                    var res = error.responseText;
                    var jsonData = JSON.parse(res);
                    var status = jsonData.status;
                    if (status === 401) {
                        alert("请登录");
                    }
                    removeLocalStorage(tkName);
                    w.location.href = "login.html";
                }
            });
        } else {
            removeLocalStorage(tkName);
            // w.location.href = "login.html";
        }
        setLocalStorage("accountBaseInfo", websiteConfig.commonUserInfo);
        return websiteConfig.commonUserInfo;
    };
    //获取当前账号在企业的角色
    $.getRole = function () {

        let role = null;
        let accountBaseInfo = JSON.parse(getLocalStorage("accountBaseInfo"));
        if (accountBaseInfo.relCorpInfo.length == 0 || !accountBaseInfo.relCorpInfo) {
            return
        }
        let corpId = accountBaseInfo.relCorpInfo[0].corpInfo.corpId;
        let requestUrl = w.websiteConfig.commonRequestUrl + "/wallet/role/" + corpId;
        $.ajax({
            type: "GET",
            async: false,
            url: requestUrl,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            beforeSend: function (request) {
                request.setRequestHeader("token", getLocalStorage(websiteConfig.tokenStringName));
            },
            success: function (data) {
                if (data.code === 0) {
                    role = data.content.role;
                }
            },
            error: function (error) {
                $.ajaxError(error);
            }
        })
        return role
    };
    $.hasAuthority = function () {
        const role = $.getRole();
        if (!!role) {
            return true
        } else {
            return false
        }
    }
    //通用用户退出登录方法
    $.userCommonLogout = function () {
        removeLocalStorage(tkName);
        var requestUrl = rUrl + "/user/logOut/";
        $.ajax({
            async: false,
            type: "GET",
            url: requestUrl,
            beforeSend: function (request) {
                request.setRequestHeader("token", thisToken);
            },
            success: function (data) {
                w.location.href = "login.html";
            },
            error: function (error) {
                w.location.href = "login.html";
            }
        });
    };
    //显示页面加载等待
    $.pageWaiting = function () {
        $("._this_page_load_waiting").remove();
        var icon = $("<i class='fa fa-refresh fa-spin _this_page_load_waiting'></i>").hide();
        icon.css({ "color": "#666", "position": "fixed", "left": "49%", "top": "46%" });
        $("body").append(icon.fadeIn("fast"));
        return this;
    };
    //删除页面加载等待
    $.removePageWaiting = function () {
        $("._this_page_load_waiting").fadeOut("fast", function () {
            $("._this_page_load_waiting").remove();
        });
        return this;
    };
    //显示通用ajax请求等待
    //msg等待提示内容
    $.addWaiting = function (msg) {
        $("._common_waiting").parent().remove();
        var w = $("<div></div>");
        var waitBlank = $("<div></div>").addClass("_common_waiting");
        var waitContent = $("<b></b>").addClass("_common_waiting_content");
        var waitIcon = "<i class='fa fa-refresh fa-spin'></i>";
        var txt = !!msg ? "&nbsp;&nbsp;" + msg : "";
        var waitTxt = "<span>" + txt + "</span>";
        waitContent.append(waitIcon).append(waitTxt);
        w.append(waitBlank).append(waitContent);
        $("body").append(w);
        var winWidth = $(window).width();
        var winHeight = $(window).height();
        var conWidth = waitContent.outerWidth();
        var conHeight = waitContent.outerHeight();
        var conLeft = Math.floor((winWidth - conWidth) / 2);
        var conTop = Math.floor((winHeight - conHeight) / 2) - 50;
        waitContent.css({ "left": conLeft + "px", "top": conTop + "px" });
        return this;
    };
    //删除通用ajax请求等待
    $.removeWaiting = function () {
        $("._common_waiting").parent().remove();
        return this;
    };
    //通用alert弹框
    //msg弹框提示内容
    $.userAlert = function (msg, callback, title) {
        $("._user_alert_card_container").parent().remove();
        var w = $("<div></div>");
        var h = $("<input type='text' value='hidden' />").css({ "opacity": "0", "position": "absolute", "left": "-99999px", "top": "-99999px" });
        var aBlank = $("<div></div>").addClass("_user_alert_card");
        var aContent = $("<div></div>").addClass("_user_alert_card_container");
        var aClose = $("<i>&times;</i>");
        var tl = title ? title : "提示"
        var aTitle = $("<h1></h1>").html(tl);
        var txt = msg ? msg : "";
        var alertContent = $("<p></p>").html(txt);
        var alertBtn = $("<a>确定</a>");
        aContent.append(aClose).append(aTitle).append(alertContent).append(alertBtn);
        w.append(h).append(aBlank).append(aContent);
        $("body").append(w);
        w.click(function () { h.focus(); });
        aBlank.click(function () { h.focus(); });
        aContent.click(function () { h.focus(); });
        aClose.click(function () {
            $("._user_alert_card_container").parent().remove();
            callback && callback();
            return false;
        });
        alertBtn.click(function () {
            $("._user_alert_card_container").parent().remove();
            callback && callback();
            return false;
        });
        h.focus().keyup(function () {
            var c = (navigator.appname === "Netscape") ? event.which : w.event.keyCode;
            if (c === 13) {
                alertBtn.click();
            }
        });
        return this;
    };
    //msg弹框提示内容(延迟自动消失)
    $.userAlertAutoHide = function (msg, time) {
        $("._user_alert_card_container").parent().remove();
        var w = $("<div></div>");
        var h = $("<input type='text' value='hidden' />").css({ "opacity": "0", "position": "absolute", "left": "-99999px", "top": "-99999px" });
        var aBlank = $("<div></div>").addClass("_user_alert_card");
        var aContent = $("<div></div>").addClass("_user_alert_card_container");
        var aClose = $("<i>&times;</i>");
        var aTitle = $("<h1>提示</h1>");
        var txt = msg ? msg : "";
        var alertContent = $("<p></p>").html(txt);
        var alertBtn = $("<a>确定</a>");
        aContent.append(aClose).append(aTitle).append(alertContent).append(alertBtn);
        w.append(h).append(aBlank).append(aContent);
        $("body").append(w);
        w.click(function () { h.focus(); });
        aBlank.click(function () { h.focus(); });
        aContent.click(function () { h.focus(); });
        aClose.click(function () {
            alertHide();
            return false;
        });
        alertBtn.click(function () {
            alertHide();
            return false;
        });
        h.focus().keyup(function () {
            var c = (navigator.appname === "Netscape") ? event.which : w.event.keyCode;
            if (c === 13) {
                alertBtn.click();
            }
        });

        function alertHide() {
            $("._user_alert_card_container").parent().remove();
        }
        if (time > 0) {
            setTimeout(alertHide, time)
        }
        return this;
    };

    //msg弹框提示内容-点击确定后将消息置为已读(方法针对未读消息提示,无通用性)
    $.userAlertHasCallback = function (title, msg, callback) {
        $("._user_alert_card_container").parent().remove();
        var w = $("<div></div>");
        var h = $("<input type='text' value='hidden' />").css({ "opacity": "0", "position": "absolute", "left": "-99999px", "top": "-99999px" });
        var aBlank = $("<div></div>").addClass("_user_alert_card");
        var aContent = $("<div></div>").addClass("_user_alert_card_container");
        var title = title ? title : '提示';
        var aTitle = $("<h1></h1>").html(title);
        var txt = msg ? msg : "";
        var alertContent = $("<p></p>").html(txt);
        var alertBtn = $("<a>我知道啦</a>");
        aContent.append(aTitle).append(alertContent).append(alertBtn);
        w.append(h).append(aBlank).append(aContent);
        $("body").append(w);
        w.click(function () { h.focus(); });
        aBlank.click(function () { h.focus(); });
        aContent.click(function () { h.focus(); });
        alertBtn.click(function () {
            $("._user_alert_card_container").parent().remove();
            if (callback) {
                callback();
            }
        });
        // return this;
    };
    //通用confirm弹框
    //msg弹框提示内容
    //func1允许后回调
    //func2拒绝后回调
    $.userConfirm = function (msg, func1, func2) {
        $("._user_alert_card_container").parent().remove();
        var w = $("<div></div>");
        var aBlank = $("<div></div>").addClass("_user_alert_card");
        var aContent = $("<div></div>").addClass("_user_alert_card_container");
        var aClose = $("<i>&times;</i>");
        var aTitle = $("<h1>提示</h1>");
        var txt = msg ? msg : "";
        var alertContent = $("<p></p>").html(txt);
        var alertBtn1 = $("<a>确定</a>");
        var alertBtn2 = $("<b>取消</b>");
        aContent.append(aClose).append(aTitle).append(alertContent).append(alertBtn1).append(alertBtn2);
        w.append(aBlank).append(aContent);
        $("body").append(w);
        aClose.click(function () {
            $("._user_alert_card_container").parent().remove();
            if (thisIsFunction(func2)) {
                func2();
            }
            return false;
        });
        alertBtn1.click(function () {
            $("._user_alert_card_container").parent().remove();
            if (thisIsFunction(func1)) {
                func1();
            }
            return false;
        });
        alertBtn2.click(function () {
            $("._user_alert_card_container").parent().remove();
            if (thisIsFunction(func2)) {
                func2();
            }
            return false;
        });
        return this;
    };
    //通用ajax异常处理
    $.ajaxError = function (error) {
        var jumpUrl = w.location.href.indexOf("/login.html") >= 0;
        var res = error.responseText;
        var jsonData = JSON.parse(res);
        var status = jsonData.status;
        console.log(jsonData);
        if (status === 401) {
            alert("此用户未授权");
            removeLocalStorage(tkName);
            if (!jumpUrl) {
                w.location.href = "login.html";
            }
        } else if (status === 500) {
            alert("系统异常");
        } else if (status === 502) {
            alert("禁止访问");
        } else if (status === 1000) {
            alert("用户已经存在");
        } else if (status === 1001) {
            alert("用户不存在");
        } else if (status === 1002) {
            alert("用户不可以解除");
        } else {
            alert("系统错误,请稍后再试");
        }
        return false;
    }
})(window, jQuery);



// WEBPACK FOOTER //
// ./src/static/js/common.js